import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../../../features/presentation/state/slice/user_slice";
import { DashboardRoute } from "../route_constants";
import { GetUserStatus } from "../../../features/presentation/state/slice/user_slice";
import { useEffect } from "react";
import { userActions } from "../../../features/presentation/di/di";
import { Outlet, Navigate } from "react-router-dom";

const WithoutUserProtection = () => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user.user);
    useEffect(() => {
        dispatch(getUser());
        return () => {
            dispatch(userActions.setGetUserStatusToInitial());
        };
    }, [dispatch]);

    const getUserStatus = useSelector((state) => state.user.getUserStatus);

    return (
        user !== null && (getUserStatus === GetUserStatus.initial || getUserStatus === GetUserStatus.complete) ?
            <Navigate to={DashboardRoute} replace /> : <Outlet />
    );
};

export default WithoutUserProtection;